var map = {
	"./giftcard_desktop_failed.svg": "1cce",
	"./investment_desktop_failed.svg": "e4dc",
	"./mkt_desktop_failed.svg": "aab0",
	"./payment_desktop_failed.svg": "742c",
	"./topup_desktop_failed.svg": "33c0",
	"./voucher_desktop_failed.svg": "690e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb07";